import * as React from 'react';
import { getDefaultCustomer } from '../Services/UserService';

interface IUsePermissions {
  isReadOnly: boolean | null;
  isCreateOnly: boolean | null;
  isUpdateOnly: boolean | null;
  isDeleteOnly: boolean | null;
  canUpdate: boolean | null;
  canRead: boolean | null;
  canDelete: boolean | null;
  canCreate: boolean | null;
}

const usePermissions = (
  resources: (string | number)[],
  customerIds?: number[] | null
): IUsePermissions => {
  let isReadOnly: boolean | null = null;
  let isUpdateOnly: boolean | null = null;
  let isDeleteOnly: boolean | null = null;
  let isCreateOnly: boolean | null = null;
  let canUpdate: boolean | null = null;
  let canDelete: boolean | null = null;
  let canCreate: boolean | null = null;
  let canRead: boolean | null = null;

  const permissions = localStorage.getItem('permissions');
  if (permissions) {
    const jsonPermissions = JSON.parse(permissions);
    // console.log('permissions: ', jsonPermissions, customerIds);
    let customers: number[] | null = null;
    if (customerIds) {
      customers = customerIds;
    } else {
      customers = getDefaultCustomer();
    }

    if (customerIds) {
      customerIds.forEach((customerId: number) => {
        // console.log('customer for permission: ', jsonPermissions[customerId], resources);
        resources.forEach((resource: string | number) => {
          if (!jsonPermissions[customerId]) {
            console.warn(`Permissions for customerId ${customerId} doesn't exists.`);
          }
          if (jsonPermissions[customerId] && !jsonPermissions[customerId][resource]) {
            console.warn(
              `Resource ${resource} for customer ${customerId} permissions doesn't exists.`
            );
          }
          if (
            jsonPermissions[customerId] &&
            jsonPermissions[customerId][resource] &&
            jsonPermissions[customerId][resource].values &&
            jsonPermissions[customerId][resource].values.includes('read') &&
            !canRead
          ) {
            canRead = true;
          }
          if (
            jsonPermissions[customerId] &&
            jsonPermissions[customerId][resource] &&
            jsonPermissions[customerId][resource].values.includes('delete') &&
            !canDelete
          ) {
            canDelete = true;
          }
          if (
            jsonPermissions[customerId] &&
            jsonPermissions[customerId][resource] &&
            jsonPermissions[customerId][resource].values.includes('update') &&
            !canUpdate
          ) {
            canUpdate = true;
          }
          if (
            jsonPermissions[customerId] &&
            jsonPermissions[customerId][resource] &&
            jsonPermissions[customerId][resource].values.includes('create') &&
            !canCreate
          ) {
            canCreate = true;
          }
        });
      });
    }

    if (canRead && !canUpdate && !canDelete && !canCreate) {
      isReadOnly = true;
    } else {
      isReadOnly = false;
    }

    if (canUpdate && !canRead && !canDelete && !canCreate) {
      isUpdateOnly = true;
    } else {
      isUpdateOnly = false;
    }

    if (canCreate && !canRead && !canDelete && !canUpdate) {
      isCreateOnly = true;
    } else {
      isUpdateOnly = false;
    }

    if (canDelete && !canRead && !canCreate && !canUpdate) {
      isDeleteOnly = true;
    } else {
      isDeleteOnly = false;
    }
  }

  const data: IUsePermissions = {
    isReadOnly,
    isUpdateOnly,
    isDeleteOnly,
    isCreateOnly,
    canRead,
    canUpdate,
    canDelete,
    canCreate,
  };

  // console.log('usePermissions: ', data);

  return data;
};

export default usePermissions;
